// 路由懒加载
const Layout = () => import('@/layout/index.vue')
const Login = () => import('@/pages/login/index.vue')

export const routes = [
    {
        path: '/login',
        name: 'Login',
        component: Login,
        meta: { title: '登录' }
    },
    {
        path: '/',
        component: Layout,
        redirect: '/home',
        children: [
            {
                path: 'home',
                name: 'Home',
                component: () => import('@/pages/home/index.vue'),
                meta: { title: '首页', requiresAuth: true }
            },
            {
                path: 'system/user',
                name: 'User',
                component: () => import('@/pages/system/user/index.vue'),
                meta: { title: '用户管理', requiresAuth: true }
            },
            {
                path: 'system/role',
                name: 'Role',
                component: () => import('@/pages/system/role/index.vue'),
                meta: { title: '角色管理', requiresAuth: true }
            },
            {
                path: 'system/menu',
                name: 'Menu',
                component: () => import('@/pages/system/menu/index.vue'),
                meta: { title: '菜单管理', requiresAuth: true }
            },
            {
                path: 'system/dept',
                name: 'Dept',
                component: () => import('@/pages/system/dept/index.vue'),
                meta: { title: '部门管理', requiresAuth: true }
            },
            {
                path: 'system/log',
                name: 'Log',
                component: () => import('@/pages/system/log/index.vue'),
                meta: { title: '日志管理', requiresAuth: true }
            },
            {
                path: 'goods/list',
                name: 'GoodsList',
                component: () => import('@/pages/goods/list.vue'),
                meta: { title: '商品管理', requiresAuth: true }
            },
            {
                path: 'order/list',
                name: 'OrderList',
                component: () => import('@/pages/order/list.vue'),
                meta: { title: '订单管理', requiresAuth: true }
            },
            {
                path: 'withdraw/list',
                name: 'WithdrawList',
                component: () => import('@/pages/withdraw/list.vue'),
                meta: { title: '提现管理', requiresAuth: true }
            },
            {
                path: 'commission/list',
                name: 'CommissionList',
                component: () => import('@/pages/commission/list.vue'),
                meta: { title: '返佣管理', requiresAuth: true }
            },
            {
                path: 'commission/bonus-pool',
                name: 'BonusPoolList',
                component: () => import('@/pages/commission/bonusPoolList.vue'),
                meta: { title: '奖金池管理', requiresAuth: true }
            },
            {
                path: 'config/switch',
                name: 'SwitchConfig',
                component: () => import('@/pages/config/switch.vue'),
                meta: { title: '小程序菜单配置', requiresAuth: true }
            },
            {
                path: '/404',
                component: () => import('@/pages/404.vue'),
                meta: { title: '404 - 页面不存在' }
            },
        ]
    },

    {
        path: '*',
        redirect: '/404'
    }
]